export var BreakpointKey;
(function (BreakpointKey) {
    BreakpointKey["zero"] = "zero";
    BreakpointKey["s"] = "s";
    BreakpointKey["m"] = "m";
    BreakpointKey["l"] = "l";
    BreakpointKey["xl"] = "xl";
})(BreakpointKey || (BreakpointKey = {}));
export var breakpointKeys = ['zero', 's', 'm', 'l', 'xl'];
export var breakpoints = {
    zero: 0,
    s: 600,
    m: 960,
    l: 1280,
    xl: 1920,
};
var step = 0.5;
export function up(key) {
    var value = typeof breakpoints[key] === 'number' ? breakpoints[key] : key;
    return "@media (min-width:" + value + "px)";
}
export function down(key) {
    var endIndex = breakpointKeys.indexOf(key) + 1;
    var upperbound = breakpoints[breakpointKeys[endIndex]];
    if (endIndex === breakpointKeys.length) {
        return up(BreakpointKey.zero);
    }
    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : 0;
    return "@media (max-width:" + (value - step) + "px)";
}
export function between(start, end) {
    var endIndex = breakpointKeys.indexOf(end) + 1;
    if (endIndex === breakpointKeys.length) {
        return up(start);
    }
    return ("@media (min-width:" + breakpoints[start] + "px) and " +
        ("(max-width:" + (breakpoints[breakpointKeys[endIndex]] - step) + "px)"));
}
export function only(key) {
    return between(key, key);
}
